import { Directive, Input } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { map, switchMapTo } from 'rxjs/operators';
import { SurveyService } from '../service/survey.service';
import { Surveys } from 'src/Models/Surveys';

@Directive({
  selector: '[appParticipantKeyValidator]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: ParticipantKeyValidatorDirective, multi: true }]
})
export class ParticipantKeyValidatorDirective implements AsyncValidator {
  @Input() survey: Surveys;
  constructor(private surveyService: SurveyService) {}

  validate(control: AbstractControl): Observable<{ [key: string]: any } | null> {
    let participant_key = '';
    const controlValue = control.value as any;
    if (typeof controlValue != 'object') {
      participant_key = control.value;
    } else {
      participant_key = control.value['e164Number'].replace('+', '').toString();
    }
    return timer(500).pipe(
      switchMapTo(this.surveyService.verifyParticipant(participant_key, this.survey.id_survey)),
      map(
        (res) => {
          return !res ? null : { partipant_key_valid: res };
        }
      )
    );
  }
}
